module.exports = __webpack_public_path__ + "static/img/blo4.80ac6172.png";